import {post, put} from '../utils'
import {getActiveClient} from "../authentication/utils";
import {request} from "../../index";

export default host => data =>
  post(`${host}/clients/${getActiveClient()}/files/many`, JSON.stringify(data))
    .then(res => res.json())